// src/components/ReadjudicacionMasiva/CrearLote/ConfirmacionLote.js

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
    Paper,
    Typography,
    Box,
    Grid
} from '@mui/material';
import {
    CheckCircle as CheckCircleIcon
} from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3)
    },
    section: {
        marginBottom: theme.spacing(3)
    },
    successBox: {
        backgroundColor: theme.palette.success.light + '20',
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2)
    },
    statBox: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.shape.borderRadius,
        textAlign: 'center'
    },
    statValue: {
        fontSize: '2rem',
        fontWeight: 700,
        color: theme.palette.primary.main
    },
    statLabel: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary
    },
    moduloBox: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.primary.light + '20',
        borderRadius: theme.shape.borderRadius,
        textAlign: 'center',
        border: `1px solid ${theme.palette.primary.main}`
    }
}));

const ConfirmacionLote = ({ expedientesSeleccionados, filtros }) => {
    const classes = useStyles();

    const calcularEstadisticas = () => {
        const total = expedientesSeleccionados.length;
        const montoTotal = expedientesSeleccionados.reduce((sum, exp) => {
            return sum + (parseFloat(exp.Monto_Total) || 0);
        }, 0);

        return {
            total,
            montoTotal
        };
    };

    const getModuloNombre = () => {
        if (filtros?.tipoEjecucion === 'tributarias') {
            return 'Ejecuciones Tributarias';
        } else if (filtros?.tipoEjecucion === 'no_tributarias') {
            return 'Ejecuciones No Tributarias';
        }
        return 'No especificado';
    };

    const stats = calcularEstadisticas();

    return (
        <Paper className={classes.paper}>
            <Box className={classes.successBox}>
                <CheckCircleIcon style={{ color: '#4caf50', fontSize: 40 }} />
                <Box>
                    <Typography variant="h6" style={{ fontWeight: 600 }}>
                        Listo para crear el lote
                    </Typography>
                    <Typography variant="body2">
                        Revise los datos y confirme la creación del lote
                    </Typography>
                </Box>
            </Box>

            {/* Estadísticas */}
            <Grid container spacing={2} className={classes.section}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box className={classes.statBox}>
                        <Typography className={classes.statValue}>
                            {stats.total}
                        </Typography>
                        <Typography className={classes.statLabel}>
                            Expedientes Seleccionados
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box className={classes.statBox}>
                        <Typography className={classes.statValue}>
                            $ {stats.montoTotal.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                        </Typography>
                        <Typography className={classes.statLabel}>
                            Monto Total
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box className={classes.moduloBox}>
                        <Typography className={classes.statValue} style={{ fontSize: '1.25rem' }}>
                            {getModuloNombre()}
                        </Typography>
                        <Typography className={classes.statLabel}>
                            Módulo
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ConfirmacionLote;
